<template>
    <div
        v-on-clickaway.self="onClickOutside"
        class="is-paddingless"
        @click.stop
    >
        <object-card
            v-if="!isClue && object.type != 'point'"
            :content="object"
            :model="model"
            :is-creation="creationEnabled"
            @delete="$emit('delete')"
            @save="saveObject"
            @addElement="emitEdit"
            @edit="
                $emit('edit', object);
                localMode = 'CREATE';
            "
        >
            <template v-if="hasUnsavedChanges && localMode == 'READ'" #message>
                <p v-t="'creation.unsaved_changes'" class="help is-danger"></p>
            </template>
        </object-card>

        <object-card-clue
            v-else-if="object.type != 'point'"
            :content="object"
            :model="model"
            :is-creation="creationEnabled"
            :resetPoint="resetPoint"
            @delete="$emit('deleteClue')"
            @save="saveClue"
            @addElement="emitEdit"
            @addPoint="editPoint"
            @edit="
                $emit('edit', object);
                localMode = 'CREATE';
            "
            @cancel="$emit('cancel')"
            @goalreseted="$emit('goalreseted')"
        >
            <template v-if="hasUnsavedChanges && localMode == 'READ'" #message>
                <p v-t="'creation.unsaved_changes'" class="help is-danger"></p>
            </template>
        </object-card-clue>

        <div
            v-for="(related, trigger) in object.triggers"
            :key="trigger"
            class="has-text-centered"
        >
            <div
                v-if="trigger != 'END' || creationEnabled"
                class="columns mb-0 is-centered"
            >
                <svg
                    preserveAspectRatio="none"
                    fill="none"
                    height="20px"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M150 0L150 80L150 80"
                        stroke="#C5CCD0"
                        stroke-width="2px"
                    />
                </svg>
            </div>
            <object-card-trigger-buttons
                :allow-active="creationEnabled"
                :triggers="triggers"
                :trigger="{ type: trigger }"
                :available-objects="availableObjects"
                :showObjectButtons="showObjectButtons"
                class="has-text-centered"
                @add="$emit('add', { ...$event, ...{ trigger } })"
                @edit="
                    $emit('edit', object);
                    localMode = 'CREATE';
                "
                @update:trigger="updateTrigger({ ...$event, ...{ trigger } })"
            />
            <div
                v-if="trigger != 'END' && !showObjectButtons"
                class="columns mb-0 is-centered"
            >
                <svg
                    preserveAspectRatio="none"
                    fill="none"
                    height="20px"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M150 0L150 80L150 80"
                        stroke="#C5CCD0"
                        stroke-width="2px"
                    />
                    <path d="M145 75H155L150 80L145 75Z" fill="#C5CCD0" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import ObjectCardSimplified from '@/components/ObjectCardSimplified';
import ObjectCard from '@/components/ObjectCard';
import ObjectCardClue from '@/components/ObjectCardClue';
import ObjectCardTriggerButtons from '@/components/ObjectCardTriggerButtons';
import vClickOutside from 'v-click-outside';
import { mixin as clickaway } from '@/directives/vue-clickaway';
import { availableObjects } from '@labygram/treasurehunt';

export default {
    name: 'ObjectCardWithTrigger',
    components: {
        ObjectCard,
        ObjectCardSimplified,
        ObjectCardTriggerButtons,
        ObjectCardClue,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    mixins: [clickaway],
    model: {
        prop: 'object',
    },
    props: {
        object: {
            type: Object,
            default() {
                return {
                    _id: 'draft',
                };
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        triggers: {
            type: Array,
            default() {
                return [];
            },
        },
        modalActive: {
            type: Boolean,
            default: false,
        },
        showObjectButtons: {
            type: Boolean,
            default: false,
        },
        resetPoint: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            localMode: this.object._id != 'draft' ? 'READ' : 'CREATE',
            objectSource: { ...this.object },
        };
    },
    computed: {
        creationEnabled() {
            return this.hasCreationPermission && this.localMode == 'CREATE';
        },
        hasCreationPermission() {
            return this.$store.getters.project.accessLevel != 'read';
        },
        hasUnsavedChanges() {
            return false;
            return !_.isEqual(this.object, this.objectSource);
        },
        availableObjects() {
            return availableObjects(this.object);
        },
        isClue() {
            const trigger = _.keys(this.object.triggers)[0];
            return trigger == 'GO_TO_POINT';
        },
        correctAnswers() {
            return _.filter(this.object.answers, (answer) => {
                if (answer.correct) {
                    return answer && answer.value;
                }
            });
        },
        cleanedAnswers() {
            return _.filter(this.object.answers, (answer) => {
                if (answer.value) {
                    return answer;
                }
            });
        },
    },
    watch: {
        object: {
            deep: true,
            handler(newObject) {
                this.objectSource = newObject;
            },
        },
        'object._id': function (newId) {
            if (newId && newId != 'draft') {
                this.localMode = 'READ';
            } else {
                this.localMode = 'CREATE';
            }
        },
    },
    methods: {
        updateTrigger({ type, trigger }) {
            if (type == trigger) {
                return;
            }
            let triggers = { ...this.object.triggers };
            Object.defineProperty(
                triggers,
                type,
                Object.getOwnPropertyDescriptor(triggers, trigger)
            );
            delete triggers[trigger];
            this.$set(this.object, 'triggers', triggers);
            this.$emit('object:update', this.object);
        },
        emitEdit(type) {
            this.$emit('edit', this.object);
            this.$emit('addElement', { type });
        },
        editPoint(point, type) {
            this.$emit('edit', point);
            this.$emit('addElement', { type });
        },
        async saveObject() {
            console.log('double validation?');
            if (this.object.type == 'question') {
                console.log('try to validate answers');
                console.log('answer type', this.object.answerType);
                if (
                    !this.object.answerType ||
                    this.object.answerType == 'EMPTY'
                ) {
                    alert(this.$t('Error.MISSING_ANSWER_TYPE'));
                    return;
                } else {
                    const responseValidator = this.questionValidator();
                    if (responseValidator !== 'ALL_OK') {
                        alert(this.$t(responseValidator));
                        return;
                    }
                }
            }

            this.$emit('update', this.object);
            this.localMode = 'READ';
        },
        async saveClue(point) {
            // console.log('saving clue');
            this.$emit('updateClue', this.object, point);
            // console.log(this.object)
            // console.log(point)
            this.localMode = 'READ';
        },
        onClickOutside(e) {
            // this.$store.dispatch("Project/disableCreation");
            //console.log('clickoutside');
            if (this.creationEnabled) {
                /*console.log(
                    'here we save the object. is correct?',
                    this.object
                );*/
                if (!this.modalActive) {
                    // console.log('no modal opened', this.modalActive);
                    if (this.object._id == 'draft') {
                        if (confirm(this.$t('confirm_cancel_creation'))) {
                            this.$emit('cancel');
                        }
                    } else {
                        if (confirm(this.$t('confirm_cancel_edition'))) {
                            this.localMode = 'READ';
                            if (
                                this.object.type == 'point' ||
                                this.object.triggers.GO_TO_POINT
                            ) {
                                // console.log('emiting from clue/point');
                                this.$emit('cancel-edition-clue');
                            } else {
                                // console.log('emiting from object');
                                this.$emit('cancel-edition-object');
                            }
                        }
                    }
                }
            }
        },
        questionValidator() {
            if (
                this.object.answerType == 'HANGMAN' ||
                this.object.answerType == 'FREETEXT'
            ) {
                if (!this.object.answers) {
                    return 'Object.errors.FILL_ANSWER';
                }
                if (this.correctAnswers.length) {
                    this.cleanAnswers(); // removes emtpy answers
                    this.object.answers = [this.correctAnswers[0]]; // ensure only one answer for this question type
                } else {
                    return 'Object.errors.MARK_CORRECT';
                }
            } else {
                if (!this.object.answers || !this.object.answers.length) {
                    return 'Object.errors.FILL_ANSWERS';
                }
                this.cleanAnswers(); // removes emtpy answers
                if (this.correctAnswers.length < 1) {
                    return 'Object.errors.MARK_CORRECT';
                }
            }
            return 'ALL_OK';
        },
        cleanAnswers() {
            this.object.answers = this.cleanedAnswers;
        },
    },
    /*mounted() {
        console.log(this.object);
    },*/
};
</script>
